import React from "react";
import Storyblok, { version } from "../../lib/storyblok-client";
import { relationsToResolve } from "@/constants/general";
import Components from "../../components/components";
import { GetBlogStories, getBlogStories } from "@/lib/storyblok-gapi";
import { getSeoFromStory } from "@/lib/seo";
import { useStoryblok } from "../../helpers/storyblok-hook";
import { isProduction } from "../../helpers/environment";
import { Story } from "@/types/storyblok";

interface Props {
  story?: Story;
  stories: GetBlogStories[];
}

export default function BlogIndex({ story, stories }: Props) {
  story = useStoryblok(story, !isProduction);

  return (
    story &&
    React.createElement(Components(story?.content?.component), {
      key: story?.uuid,
      content: story?.content,
      published: story.published_at,
      stories: stories,
    })
  );
}

export async function getStaticProps() {
  try {
    const blogStories = await getBlogStories();
    const {
      data: { story },
    } = await Storyblok.get(`cdn/stories/blog`, {
      resolve_relations: relationsToResolve,
      version,
    });

    return {
      props: {
        story,
        stories: blogStories?.BlogItems?.items,
        seo: await getSeoFromStory({ story }),
        revalidate: 86400,
      },
    };
  } catch (error) {
    console.log(error);
    return {
      notFound: true,
    };
  }
}
